import { cn } from '@/lib/utils';

interface ShiftTotalBannerProps {
  fixedValue: number;
  itemsTotal: number;
  total: number;
  itemsCount: number;
  serviceName?: string;
  serviceColor?: string;
  className?: string;
}

export function ShiftTotalBanner({
  fixedValue,
  itemsTotal,
  total,
  itemsCount,
  serviceName,
  serviceColor,
  className,
}: ShiftTotalBannerProps) {
  return (
    <div
      className={cn(
        'sticky top-0 z-20 flex flex-wrap items-center justify-between gap-3 border-b border-(--color-border) bg-(--color-surface) px-4 py-3 shadow-sm',
        className,
      )}
      aria-live="polite"
    >
      <div className="flex items-center gap-3">
        {serviceColor && (
          <span
            className="h-4 w-4 shrink-0 rounded-sm"
            style={{ backgroundColor: serviceColor }}
            aria-hidden="true"
          />
        )}
        <div>
          <p className="text-sm font-medium">{serviceName ?? 'Plantão'}</p>
          <p className="text-xs text-(--color-fg-muted)">
            {itemsCount} {itemsCount === 1 ? 'procedimento' : 'procedimentos'} · fixo{' '}
            {brl(fixedValue)} · itens {brl(itemsTotal)}
          </p>
        </div>
      </div>
      <div className="text-right">
        <p className="text-xs text-(--color-fg-muted)">Total</p>
        <p className="font-display text-xl font-semibold text-(--color-accent) tabular-nums">
          {brl(total)}
        </p>
      </div>
    </div>
  );
}

function brl(v: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
}
